<template>
  <div class="index-overview"> 
    <div class="recent-purchases">
      <RecentPurchasesVue />
    </div>
    <div class="year-to-date">
      <YearToDateVue />
    </div>
    <div class="five-year-bar-chart full-width">
      <FiveYearBarChart />
    </div>
  </div>
</template>

<script>
import RecentPurchasesVue from '@/components/blocks/RecentPurchases'
import YearToDateVue from '@/components/blocks/YearToDate'
import FiveYearBarChart from '@/components/blocks/FiveYearBarChart'

export default {
  name: 'IndexOverview',

  components: {
    RecentPurchasesVue,
    YearToDateVue,
    FiveYearBarChart,
  }
}
</script>

<style lang="scss">
.index-overview {
  font-size: 20px;
  padding: $padding;
  display: grid;
  grid-template-areas:
    "left right";
  grid-template-columns: 1fr 1fr;
  gap: $margin;

  .full-width {
    grid-column: 1 / 3;
  }

  .block {
    font-size: $font;
  }

  @media screen and (max-width: $mobile-break) {
    grid-template-areas: "one";
    grid-template-columns: 1fr;
    gap: unset;

    .full-width {
      grid-column: 1 / 2;
    }
  }
}
</style>
